import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpModule } from '@angular/http';
import { AlertComponent } from './alert/alert.component';
import { AlertService } from './alert.service';
import { DatetimepickerComponent } from './datetimepicker/datetimepicker.component';
import { FormsService } from './forms.service';
import { PromoApplyToPipe } from './pipes/promo-apply-to.pipe';
import { TableComponent } from './table/table.component';
import {InitjsService} from './initjs.service';
import {ImageUploaderModule} from '../image-uploader/image-uploader.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    ImageUploaderModule
  ],
  declarations: [
    AlertComponent,
    DatetimepickerComponent,
    PromoApplyToPipe,
    TableComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    AlertComponent,
    DatetimepickerComponent,
    PromoApplyToPipe,
    TableComponent,
    ImageUploaderModule
  ],
  providers: [
    AlertService,
    FormsService,
    InitjsService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts